export default __webpack_public_path__ + "static/media/IntroductionWebpage.dc6248a2.gif";